<template>
    <el-row :gutter="20" class="Auth fullWidth">
        <el-col :sm="12" :md="10" :lg="8">
            <h1>Boas vindas à Simple Organic.</h1>
            <el-card class="Auth__Form">
                <b slot="header">Entrar em Simple Organic Workspace</b>
                <el-form :label-position="'top'" :model="authForm" ref="authForm">
                    <el-form-item size="large">
                        <el-button type="primary" @click="doAuthenticateWithGoogle" block
                            :loading="DashboardStatus.Auth.login === 'LOADING'">
                            <i class="el-icon-user"></i>
                            {{ DashboardStatus.Auth.login === 'LOADING' ? 'Entrando...' : 'Entrar com Google' }}
                        </el-button>
                    </el-form-item>
                    <el-alert v-if="errorMessage" :title="errorMessage" type="error" show-icon :closable="false"
                        style="margin-top: 10px;">
                    </el-alert>
                </el-form>
            </el-card>
        </el-col>
    </el-row>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    data() {
        return {
            errorMessage: '',
            authForm: {
                email: '',
                password: '',
            }
        };
    },
    computed: {
        ...mapGetters(['DashboardStatus', 'UserData'])
    },
    created() {
        if (this.UserData.token) {
            this.$router.push('/');
        }
    },
    methods: {
        ...mapActions(['authenticateWithGoogle']),
        async doAuthenticateWithGoogle() {
            this.errorMessage = '';
            try {
                await this.authenticateWithGoogle();
            } catch (error) {
                this.errorMessage = error.message || 'Erro ao fazer login. Verifique se você está usando um email @simpleorganic.com.br autorizado.';
            }
        }
    },
    watch: {
        'UserData.token'(newToken) {
            if (newToken) {
                this.$router.push('/');
            }
        }
    }
};
</script>

<style></style>
